var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisabledCoverageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.979.41a1.48 1.48 0 0 1 2.043 0l.015.014C14.822 2.202 16.91 3.1 19.61 3.255c1.295.074 2.325 1.169 2.344 2.492.004.272.01.516.021.746v.019c.053 2.819.118 6.327-1.033 9.515-.63 1.749-1.585 3.268-2.837 4.518-1.425 1.422-3.291 2.552-5.547 3.358A1.69 1.69 0 0 1 12 24a1.653 1.653 0 0 1-.558-.097C9.184 23.1 7.316 21.97 5.89 20.547c-1.253-1.249-2.207-2.768-2.838-4.516-1.146-3.179-1.081-6.68-1.029-9.494l.002-.044c.01-.232.017-.476.02-.745.02-1.324 1.05-2.419 2.344-2.492C7.09 3.1 9.18 2.202 10.964.424Zm1.02 5.61c-3.227 0-5.852 2.682-5.852 5.98 0 3.298 2.625 5.982 5.853 5.982 3.227 0 5.853-2.684 5.853-5.982S15.227 6.02 12 6.02Zm0 1.408c2.468 0 4.476 2.051 4.476 4.572 0 2.522-2.008 4.573-4.475 4.573-2.468 0-4.475-2.051-4.475-4.573 0-2.521 2.007-4.572 4.475-4.572Z",
    fill: "var(--tru-grey-400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.547 15 1.63-3.015-1.53-2.853h1.475l.514 1.107c.066.138.132.283.197.436.066.153.141.323.225.509h.037c.065-.186.13-.355.193-.508.063-.154.124-.299.184-.437l.469-1.107h1.412l-1.52 2.916L14.453 15h-1.476l-.586-1.197-.211-.464c-.069-.153-.146-.319-.23-.499h-.035c-.066.18-.133.346-.198.5a71.85 71.85 0 0 0-.199.463L10.97 15H9.549Z",
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "var(--tru-grey-400)",
    strokeWidth: 3,
    strokeLinecap: "square",
    d: "M2 30.5h20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledCoverageIcon);
export default ForwardRef;